import { cloned } from '@/helpers'

const _EMPTY_USER = {
  id: '',
  account_id: '',
  email: '',
  password: '',
  names: '',
  surnames: '',
  roles: []
}

export const User = {
  
  empty () {
    return cloned(_EMPTY_USER)
  },

  import (o) {
    return cloned(o)
  },

  export (o) {
    return cloned(o)
  },

  get () {
    var o = JSON.parse(localStorage.getItem('profile'))
    return o
  },

  save (o) {
    console.log("User.js save initiate with ", o)
    localStorage.setItem('profile', JSON.stringify(o))
  }
}
